// extracted by mini-css-extract-plugin
module.exports = {"placeholder":"CartContent_placeholder__1ARxU","placeholderLabel":"CartContent_placeholderLabel__cSnAR"};